import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getInvoiceData} from '../../../apis/leader/getInvoiceData'

const useQueryGetInvoiceData = () => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getInvoiceData(),
        staleTime: 120 * 1000,
        queryFn: async () => {
            const {data} = await getInvoiceData()
            return {data}
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    })

    return {data, refetch}
}

export default useQueryGetInvoiceData
